<template>
  <div class="teaching-score-input-title">
    <div class="title">
      <div class="label">{{label}}</div>
      <div class="scale">({{scale}}%)</div>
    </div>
    <div v-if="clearable"
         class="extra">
      <el-button size="mini"
                 type="primary"
                 plain
                 icon="el-icon-delete"
                 round
                 @click="handleClear"></el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeachingScoreInputTitle',
  props: {
    label: {
      type: String,
      required: true
    },
    scale: {
      type: Number,
      required: true
    },
    clearable: Boolean
  },
  methods: {
    handleClear () {
      this.$confirm(`确定要清除已录入的${this.label}吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('clear')
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss">
  .teaching-score-input-title {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    vertical-align: middle;
    & > .title {
      & > .scale {
        font-weight: normal;
        line-height: 100%;
        transform: scale(.9);
      }
    }
    & > .extra {
      margin-left: 8px;
      .el-button {
        padding: 2px;
        border: none;
      }
    }
  }
</style>
